import get from 'lodash/get';
import { AssetsGroupAssetsDTO } from '../../../api/useEstatePlanningFlowQuery';
import { AssetGroup, CategoryData, LiquidityKeys, EstateKeys } from '../FlowTable.meta';

interface GetAssetsParams {
  data: CategoryData;
  liquidityKey: LiquidityKeys;
  estateKey: EstateKeys;
  defaultValue: AssetGroup;
}

export const getAssets = ({
  data,
  estateKey,
  liquidityKey,
  defaultValue,
}: GetAssetsParams): AssetGroup => {
  return (get(data, [estateKey, liquidityKey, 'groupAssets'], []) as AssetsGroupAssetsDTO[]).reduce(
    (assetAcc, asset) => {
      return {
        ...assetAcc,
        [asset.assetTypeText]: {
          ...get(assetAcc, [asset.assetTypeText], {}),

          totals: [
            ...get(assetAcc, [asset.assetTypeText, 'totals'], []),
            {
              headerId: data.headerId,
              value: asset.total,
              collapsed: data.collapsed,
              headerName: data.headerName,
            },
          ],

          child: asset.groupAssets.reduce((childAcc, childAsset) => {
            return {
              ...childAcc,
              [childAsset.assetId]: [
                ...get(childAcc, [childAsset.assetId], []),
                {
                  name: childAsset.name,
                  headerId: data.headerId,
                  description: childAsset.description,
                  additionalInfo: childAsset.additionalInfo,
                  assetId: childAsset.assetId,
                  value: childAsset.value,
                  collapsed: data.collapsed,
                },
              ],
            };
          }, get(assetAcc, [asset.assetTypeText, 'child'], {})),
        },
      };
    },
    defaultValue,
  );
};
